export const AXP_THEMES = [
  "light",
  "dark",
  "commercial-light",
  "commercial-dark",
  "open-source-light",
  "open-source-dark",
  "research-light",
  "research-dark",
  "infra-light",
  "infra-dark",
  "ai-light",
  "ai-dark",
  "light-colorblind",
  "dark-colorblind",
] as const;

/**
 * Compatibility registry for apps that still use the Réseau theme names.
 * Platform-app intentionally stays on AXP_THEMES.
 */
export const R_THEMES = [
  "light",
  "dark",
  "mist-light",
  "mist-dark",
  "stone-light",
  "stone-dark",
  "mauve-light",
  "mauve-dark",
  "olive-light",
  "olive-dark",
  "light-colorblind",
  "dark-colorblind",
] as const;

export type RTheme = (typeof R_THEMES)[number] | "system";

export function normalizeRTheme(theme: string | undefined, fallback: RTheme): RTheme {
  return theme === "system" || R_THEMES.includes(theme as (typeof R_THEMES)[number])
    ? (theme as RTheme)
    : fallback;
}
